<p-dropdown
        [options]="this.filtersService.filters"
        [(ngModel)]="this.filtersService.selectedFilter"
        (onChange)="this.filtersService.calculateDateRange($event)"
        optionLabel="descripcion"
        ></p-dropdown>
<p-calendar [(ngModel)]="this.filtersService.selectedRange"
            selectionMode="range"
            class="p-1"
            styleClass="no-bg"
            dateFormat="dd/mm/yy"
            inputId="icondisplay"
            placeholder="Filtrar por fechas"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [readonlyInput]="true"
            (onSelect)="this.filtersService.onSelect()"/>
